import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { RootState } from '@/store';
import { billingContactsApi, formatError } from '@/services/api';

export const fetchAll = createAsyncThunk(
  'organization-billing-contact/fetchAll',
  async (_, { getState, rejectWithValue }) => {
    const rootState = getState() as RootState;
    const organizationId = rootState.auth.current.organization.id;
    try {
      const response = await billingContactsApi.getList({
        data: { organizationId },
      });
      return response;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response !== undefined) {
        return rejectWithValue({ error: formatError(error.response) });
      }
      throw error;
    }
  },
);
